// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1d-Sj","header":"PatientBlock_header__2oj5H","label":"PatientBlock_label__nQ2hE","option":"PatientBlock_option__1zDlX"};